import { Component } from '@angular/core';
import { BaseCtl, ServiceLocatorService } from '@ncs/ncs-lib';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-payment-gateway-config',
  templateUrl: './payment-gateway-config.component.html',
  styleUrls: ['./payment-gateway-config.component.scss'],
})
export class PaymentGatewayConfigComponent extends BaseCtl {
  paymentConfigForm = {
    data: {} as any
  };

  gateways: string[] = ['Razorpay', 'PHONEPE'];
  appId: any = 0;
  id: any = 0;
  allGateway: any = [];
  selectedGatewayName: string = '';

  constructor(serviceLocator: ServiceLocatorService, route: ActivatedRoute) {
    super('endpoint.payment', serviceLocator, route);

    this.appId = Number(route.snapshot.paramMap.get('appId'));
    this.id = Number(route.snapshot.paramMap.get('id'));
    
    // Load all gateways first, then handle auto-selection
    this.getPaymentGateways();
  }

  /**
   * Save Payment Configuration
   */
  public savePaymentConfig() {
    let url = this.locator.config.get('endpoint.payment') + '/paymentConfiguration';
    const keySuffix = this.locator.config.get('CONTEXT_PATH') + '-';
    let sid = localStorage.getItem(keySuffix + 'sessionId') || '0';
    if (url) url += ';jsessionid=' + sid;

    this.paymentConfigForm.data['appId'] = this.appId;
    const payload = { ...this.paymentConfigForm.data } as any;

    // Check if gateway already exists (only for new records)
    const existingGateway = this.allGateway.find(
      (item: any) => item.gatewayName === payload.gatewayName
    );

    if (existingGateway && !payload.id) {
      this.form['message'] = 'Configuration for this payment gateway already exists.';
      this.form['error'] = true;
      return;
    }

    if (payload._id) {
      delete payload['_id'];
    }
    console.log("this is my payload ",payload)
    this.locator.http.post(url, payload, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error: ' + error);
        return;
      }

      if (res.success) {
        this.form['message'] = res.result?.message || 'Payment configuration saved successfully!';
        this.form['error'] = false;
        this.paymentConfigForm.data = res.result.data;
        
        // Refresh the gateways list after save
        this.getPaymentGateways();
      } else {
        this.form['message'] = res.result?.message || 'Failed to save payment configuration';
        this.form['error'] = true;
      }
    });
  }

  /**
   * Fetch Payment Gateway Info by ID
   */
  getPaymentGatewaysInfo(id: any, callback?: () => void) {
    this.locator.config
      .getProperty('endpoint.payment')
      .then((property: string) => {
        let url = property + '/get/' + id;
        const keySuffix = this.locator.config.get('CONTEXT_PATH') + '-';
        let sid = localStorage.getItem(keySuffix + 'sessionId') || '0';
        if (url) url += ';jsessionid=' + sid;

        this.locator.http.get(url, (res: any, error: boolean) => {
          if (error) {
            alert('Server Error:' + error);
            return;
          }

          const result = res.result?.data;
          if (!result) {
            console.error('No data returned for gateway');
            return;
          }

          this.paymentConfigForm.data = result;
          this.selectedGatewayName = result.gatewayName;
          if (callback) callback();
        });
      });
  }

  /**
   * Get all payment gateways and auto-select first one
   */
  async getPaymentGateways(): Promise<void> {
    try {
      const property: string = await this.locator.config.getProperty(
        'endpoint.payment'
      );
      let url = property + '/search/0';

      const keySuffix = this.locator.config.get('CONTEXT_PATH') + '-';
      const sid = localStorage.getItem(keySuffix + 'sessionId');
      if (sid) url += ';jsessionid=' + sid;

      const searchData = { appId: this.appId };

      this.locator.http.post(url, searchData, (res: any, error: boolean) => {
        if (error) {
          alert('Server Error: ' + error);
          return;
        }
        
        this.allGateway = res.result?.data || [];
        
        if (this.allGateway.length > 0) {
          // If editing existing gateway (id provided in URL)
          if (this.id && this.id != 0) {
            const editGateway = this.allGateway.find((g: any) => g.id == this.id);
            if (editGateway) {
              this.getPaymentGatewaysInfo(editGateway.id);
            }
          } else {
            // Auto-select first gateway on page load
            const firstGateway = this.allGateway[0];
            this.selectedGatewayName = firstGateway.gatewayName;
            this.getPaymentGatewaysInfo(firstGateway.id);
          }
        } else {
          // No gateways exist - show empty form with first gateway selected
          this.selectedGatewayName = this.gateways[0];
          this.paymentConfigForm.data = {
            gatewayName: this.gateways[0],
            isActive: 0
          };
        }
      });
    } catch (err) {
      console.error('Error fetching gateways:', err);
      alert('Failed to load payment gateways.');
    }
  }

  /**
   * Handle gateway change from dropdown
   */
  onGatewayChange() {
    const selectedGateway = this.paymentConfigForm.data.gatewayName;
    console.log("User selected:", selectedGateway);

    if (!selectedGateway) return;

    // Check if this config exists
    const found = this.allGateway.find(
      (g: any) => g.gatewayName === selectedGateway
    );

    if (found) {
      // 🟢 Load existing config from backend
      this.getPaymentGatewaysInfo(found.id);
    } else {
      // ❗ Gateway config does NOT exist → show empty form
      this.paymentConfigForm.data = {
        gatewayName: selectedGateway,
        isActive: 0
      };
      this.selectedGatewayName = selectedGateway;
    }
  }

  /**
   * Go back
   */
  override goBack() {
    window.history.back();
  }
  hideApiSecret = true;
}